module.exports = __webpack_public_path__ + "static/media/qna.a1ae9b40.svg";